import React, { useState, useEffect } from 'react';
import apiClient from '../../apiClient';
import Table from '../common/Table/Table';
// import './WhatsAppMessages.css';

const WhatsAppMessages = () => {
  const [messages, setMessages] = useState([]);
  const [newName, setNewName] = useState('');
  const [newText, setNewText] = useState('');
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState('');
  const [editText, setEditText] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchTemplates = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await apiClient.get('/api/wptemplates');
      setMessages(response.data);
    } catch (err) {
      setError('Failed to load templates');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  const handleAddMessage = async () => {
    if (newName.trim() === '' || newText.trim() === '') return;
    setLoading(true);
    setError('');
    try {
      const response = await apiClient.post('/api/wptemplates', {
        name: newName.trim(),
        content: newText.trim()
      });
      setMessages([...messages, response.data]);
      setNewName('');
      setNewText('');
    } catch (err) {
      setError('Failed to add template');
    } finally {
      setLoading(false);
    }
  };

  const handleEditMessage = (id) => {
    const msg = messages.find(m => m.id === id);
    setEditId(id);
    setEditName(msg ? msg.name : '');
    setEditText(msg ? msg.content : '');
  };

  const handleSaveEdit = async () => {
    if (editName.trim() === '' || editText.trim() === '') return;
    setLoading(true);
    setError('');
    try {
      const response = await apiClient.put(`/api/wptemplates/${editId}`, {
        name: editName.trim(),
        content: editText.trim()
      });
      const updatedMessages = messages.map(m => m.id === editId ? response.data : m);
      setMessages(updatedMessages);
      setEditId(null);
      setEditName('');
      setEditText('');
    } catch (err) {
      setError('Failed to update template');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteMessage = async (id) => {
    setLoading(true);
    setError('');
    try {
      await apiClient.delete(`/api/wptemplates/${id}`);
      const updatedMessages = messages.filter(m => m.id !== id);
      setMessages(updatedMessages);
      if (editId === id) {
        setEditId(null);
        setEditName('');
        setEditText('');
      }
    } catch (err) {
      setError('Failed to delete template');
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { header: 'Template Name', className: 'name-column' },
    { header: 'Message', className: 'message-column' },
    { header: 'Actions', className: 'actions-header' }
  ];

  const renderRow = (message) => (
    <>
      <td>
        {editId === message.id ? (
          <input
            type="text"
            value={editName}
            onChange={(e) => setEditName(e.target.value)}
          />
        ) : (
          message.name
        )}
      </td>
      <td>
        {editId === message.id ? (
          <input
            type="text"
            value={editText}
            onChange={(e) => setEditText(e.target.value)}
          />
        ) : (
          message.content
        )}
      </td>
      <td className="actions-cell">
        {editId === message.id ? (
          <>
            <button onClick={handleSaveEdit} disabled={loading}>Save</button>
            <button onClick={() => setEditId(null)} disabled={loading}>Cancel</button>
          </>
        ) : (
          <>
            <button onClick={() => handleEditMessage(message.id)} disabled={loading}>Edit</button>
            <button onClick={() => handleDeleteMessage(message.id)} disabled={loading}>Delete</button>
          </>
        )}
      </td>
    </>
  );

  return (
    <div className="whatsapp-messages-container">
      <h2>Predefined WhatsApp Messages</h2>
      {error && <div className="error-message">{error}</div>}
      <div className="add-message">
        <input
          type="text"
          placeholder="Enter template name"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          disabled={loading}
        />
        <input
          type="text"
          placeholder="Enter message"
          value={newText}
          onChange={(e) => setNewText(e.target.value)}
          disabled={loading}
        />
        <button onClick={handleAddMessage} disabled={loading}>Add</button>
      </div>
      {loading ? (
        <div>Loading...</div>
      ) : (
        <Table 
          columns={columns} 
          data={messages} 
          renderRow={renderRow} 
          className="whatsapp-messages-table"
        />
      )}
    </div>
  );
};

export default WhatsAppMessages;
